import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { clearAuthUser, getAuthUser, saveAuthUser } from "../utils/auth";
import { apiFetch } from "../utils/apiClient";
import SynergyDashboard from "./SynergyDashboard";

export default function Dashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(() => getAuthUser());
  const userId = user?.id || user?._id || null;

  useEffect(() => {
    if (!userId) {
      return;
    }

    let ignore = false;

    const refreshProfile = async () => {
      try {
        const response = await apiFetch("/users/profile");
        if (!ignore && response?.user) {
          saveAuthUser(response.user);
          setUser(response.user);
        }
      } catch (error) {
        // ignore profile refresh failures; dashboard will use cached data
      }
    };

    refreshProfile();

    return () => {
      ignore = true;
    };
  }, [userId]);

  const handleSignOut = () => {
    clearAuthUser();
    navigate("/login", { replace: true });
  };

  return <SynergyDashboard user={user} onSignOut={handleSignOut} />;
}
